import React from "react";
import {useTranslation} from "@unibuddy/intl";
import {View, Box, Text} from "@unibuddy/patron";
import {useLocation} from "react-router-dom";

import {UnibuddyLogoInlineSvg} from "./UnibuddyLogoInlineSvg";
import {IntlNamespaces} from "../../../../translations/types";
import {INTL_SIGNIN} from "../../../../translations/login";
import {INTL_ALREADY_HAVE_AN_ACCOUNT} from "../../../../translations/signup";
import {INTL_CREATE_ACCOUNT} from "../../../../translations/chat";
import {ThemedRelativeLink} from "./ThemedRelativeLink";

export function RegisterPage1Heading() {
    const {t} = useTranslation([IntlNamespaces.SIGNUP, IntlNamespaces.LOGIN, IntlNamespaces.CHAT]);
    const loginText = t(`${IntlNamespaces.LOGIN}:${INTL_SIGNIN.key}`, INTL_SIGNIN.defaultValue);
    const alreadyHaveAnAccountText = t(
        `${IntlNamespaces.SIGNUP}:${INTL_ALREADY_HAVE_AN_ACCOUNT.key}`,
        INTL_ALREADY_HAVE_AN_ACCOUNT.defaultValue,
    );

    const location = useLocation();

    return (
        <View gap="small-medium" alignItems="center">
            <UnibuddyLogoInlineSvg />
            <Text size="large" align="center" weight="700">
                {t(
                    `${IntlNamespaces.CHAT}:${INTL_CREATE_ACCOUNT.key}`,
                    INTL_CREATE_ACCOUNT.defaultValue,
                )}{" "}
                &nbsp;
            </Text>
            <Box display="flex" alignItems="center">
                <Text size="small">{alreadyHaveAnAccountText} &nbsp;</Text>
                <Text>
                    <ThemedRelativeLink
                        to={{
                            pathname: location.pathname.replace("register", "login"),
                            search: location.search,
                            state: location.state,
                        }}
                    >
                        {loginText}
                    </ThemedRelativeLink>
                </Text>
            </Box>
        </View>
    );
}
